var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebookAvatar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 20,
    viewBox: "0 0 11 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.2507 0.471716V3.50181H8.44867C7.79062 3.50181 7.34681 3.63954 7.11726 3.915C6.88771 4.19047 6.77293 4.60366 6.77293 5.15459V7.32386H10.1359L9.68825 10.7212H6.77293V19.4328H3.26078V10.7212H0.333984V7.32386H3.26078V4.82174C3.26078 3.39851 3.65867 2.29475 4.45445 1.51044C5.25023 0.726137 6.31 0.333984 7.63376 0.333984C8.75856 0.333984 9.63086 0.379895 10.2507 0.471716Z",
    fill: "#4267B2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookAvatar);
export default __webpack_public_path__ + "static/media/facebookAvatar.62316ecef36c56f792545027ff310423.svg";
export { ForwardRef as ReactComponent };